import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setUpperPopup } from '../store/reducers/general.js'
import { addTeam,setCurrentTeam } from '../store/reducers/user.js'
import { teamService } from '../services/team.js'
import { uploadFile } from '../services/upload.js'
import { Loader } from '../cmps/loader.jsx'
import { Login } from './login.jsx'
import { useNavigate } from 'react-router-dom'


export function CreateTeam() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const name = useRef(null)
    const [image, setImage] = useState(null)
    const [loader, setLoader] = useState(false)
    const user = useSelector(state => state.user)

    const createNewTeam = async () => {
        try {
            if (!name.current.value) return dispatch(setUpperPopup('error-name'))
            if (!image) return dispatch(setUpperPopup('empty-image'))
            const t = {
                channelName: name.current.value,
                channelImage: image,
                members: [{ _id: user._id, roles: ['admin'], name: user.name, img: user.img, email: user.email }],
            }
            const newTeam = await teamService.createTeam(t)
            dispatch(addTeam(newTeam))
            dispatch(setCurrentTeam(newTeam))
            dispatch(setUpperPopup('team-created'))
            navigate('/team')
        }
        catch (err) {
            console.log(err)
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const onImageChange = async (ev) => {
        try {
            setLoader(true)
            if (!ev.target.files[0]) return setLoader(false)
            if (!ev.target.files[0].type.startsWith('image/')) {
                setLoader(false)
                dispatch(setUpperPopup('image-only'))
                return
            }
            const { secure_url } = await uploadFile(ev.target.files[0])
            setImage(secure_url)
            setLoader(false)
        }
        catch (err) {
            dispatch(setUpperPopup('errorServer'))
            setLoader(false)
        }
    }

    if(!user._id) return <Login />

    return <div className='profile channel'>
        <div className='center'>
            <div className='img-wrapper' style={{marginLeft:'0px'}}>
            {loader ? <Loader /> : <>
                <input type="file" className="non-appear" accept="image/*" id='image-create' onChange={onImageChange} />
                <label htmlFor='image-create' className='clickable'>
                    {image ? <img src={image} alt='channel' /> :
                        <span className="material-symbols-outlined">add_a_photo</span>}
                </label>
            </>}
        </div>
        <h3>שם הצוות</h3>
        <input className='input-new' maxLength={20} placeholder='שם הצוות' ref={name} />
        <button className='button-new arise' onClick={createNewTeam}>צור צוות חדש</button>
        </div>
    </div>
}